import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdComputer } from "react-icons/md";
import { MdOutlineElectricBolt } from "react-icons/md";
import ElectricityDetails from "./ElectricityDetails";
import AdvanceRent from "./AdvanceRent";
import Security from "./Security";
import Maintenance from "./Maintenance";
import Food from "./Food";
import Fine from "./Fine";
import RegistrationCharges from "./RegistrationCharges";
import WifiCharges from "./WifiCharges";
import GasCharges from "./GasCharges";
import MaidCharges from "./MaidCharges";
import DamageCharges from "./DamageCharges";
import KeyLossCharges from "./KeyLossCharges";
import LaundryBill from "./LaundryBill";
import OthersModal from "./OthersModal";
import { CiCalendarDate } from "react-icons/ci";
import { MdFoodBank} from "react-icons/md";
import { GiAutoRepair } from "react-icons/gi";
import { MdShield } from "react-icons/md";
import { GiNotebook } from "react-icons/gi";
import { FaWifi } from "react-icons/fa";
import { MdGasMeter } from "react-icons/md";
import { FaBroom } from "react-icons/fa";
import { FaKey } from "react-icons/fa";
import { GiWashingMachine } from "react-icons/gi";
import { FaHouseDamage } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";
import TechCharges from "./TechCharges";
import { HiDocumentText } from "react-icons/hi";
import AgreementCharges from "./AgreementCharges";

const AddDuesModal = ({ setIsAddDuesModal }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const selectOptions = [
        { value: "1", label: "Rent" },
  { value: "2", label: "Security" },
  { value: "3", label: "Maintenance" },
  { value: "4", label: "Electricity" },
  { value: "5", label: "Registration Charges" },
  { value: "6", label: "Tech Charges" },
  { value: "7", label: "Others" },
  { value: "8", label: "Agreement Charges" },
  { value: "9", label: "Food" },
  { value: "10", label: "Fine" },
  { value: "11", label: "Settlement" },
  { value: "12", label: "Wifi Charges" },
  { value: "13", label: "Gas Charges" },
  { value: "14", label: "Maid Charges" },
  { value: "15", label: "Damage Charges" },
  { value: "16", label: "Key Charges" },
  { value: "17", label: "Laundry Bill" },
  { value: "19", label: "Move-Out charges" },
  { value: "20", label: "Guest Charges" },
    ];

    const renderContent = () => {
        switch (selectedOption) {
            case "1":
                return <AdvanceRent setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
             case "2":
                return <Security setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "3":
                return <Maintenance setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "4":
                return <ElectricityDetails setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "5":
                return <RegistrationCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "6":
                return <TechCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;    
             case "7":
                return <OthersModal setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "8":
                return <AgreementCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;        
            case "9":
                return <Food setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "10":
                return <Fine setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "12":
                return <WifiCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "13":
                return <GasCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "14":
                return <MaidCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "15":
                return <DamageCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "16":
                return <KeyLossCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
            case "17":
                return <LaundryBill setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
           
            default:
                return (
                    <Form>
                        <Wrapper>
                            <DuesGroup>
                                {selectOptions.map((option) => (
                                    <DuesOption
                                        key={option.value}
                                        onClick={() => {
                                            setSelectedOption(option.value);
                                        }}
                                    >
                                        <RadioContainer>
                                            <RadioCircle isSelected={selectedOption === option.value} />
                                            <span className="text-sm">{option.label}</span>
                                        </RadioContainer>
                                    </DuesOption>
                                ))}
                            </DuesGroup>
                        </Wrapper>
                    </Form>
                );
        }
    };
    const renderHeader = () => {
        switch (selectedOption) {
            case "1":
                return (
                    <ProfileSection>
                        <UserImage>
                            <CiCalendarDate size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Advance Rent</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "2":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdShield size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Security</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "3":
                return (
                    <ProfileSection>
                        <UserImage>
                            <GiAutoRepair size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Maintenance</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "4":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdOutlineElectricBolt size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Electricity</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "5":
                return (
                    <ProfileSection>
                        <UserImage>
                            <GiNotebook size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Registration Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
                case "6":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdComputer  size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Tech Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "7":
                return (
                    <ProfileSection>
                        <UserImage>
                            <FaWallet  size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Others</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "8":
                return (
                    <ProfileSection>
                        <UserImage>
                            <HiDocumentText  size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Agreement Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );         
            case "9":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdFoodBank size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Food</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "10":
                return (
                    <ProfileSection>
                        <UserImage>
                            <GiAutoRepair size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Fine</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "12":
                return (
                    <ProfileSection>
                        <UserImage>
                            <FaWifi size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Wifi Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "13":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdGasMeter size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Gas Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "14":
                return (
                    <ProfileSection>
                        <UserImage>
                            <FaBroom  size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Maid Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "15":
                return (
                    <ProfileSection>
                        <UserImage>
                            <FaHouseDamage size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Damage Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "16":
                return (
                    <ProfileSection>
                        <UserImage>
                            <FaKey size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Key Loss Charges</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "17":
                return (
                    <ProfileSection>
                        <UserImage>
                            <GiWashingMachine size={18} color="#0078BD" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Laundry Bill</span>
                        </UserInfo>
                    </ProfileSection>
                ); 
            default:
        }
    };
    return (
        <Container>
            <Header>
                <Title>{selectedOption ? "Add Dues" : "Select Dues Type"}</Title>
                <CloseButton onClick={() => setIsAddDuesModal(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            {renderHeader()}
            <Content>
                {renderContent()}
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Form = tw.form`flex flex-col h-full justify-between`;
const Wrapper = tw.div`grid gap-6 my-6`;
const DuesGroup = tw.div`flex flex-col gap-3 `;
const DuesOption = tw.div`
    flex flex-col gap-2 p-4 border rounded-lg cursor-pointer
    transition-all duration-200 hover:bg-gray-100
`;
const RadioContainer = tw.div`flex items-center gap-3 `;
const RadioCircle = ({ isSelected }) => (
    <div
        className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${isSelected ? "border-blue-500" : "border-gray-500"
            }`}
    >
        {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
    </div>
);
const UserImage = tw.div`flex w-8 h-8 rounded-full  bg-blue-200 justify-center items-center `;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 py-5`;
const UserInfo = tw.div`flex flex-col`;

export default AddDuesModal;







// import React, { useState } from "react";
// import tw from "tailwind-styled-components";
// import { MdClose } from "react-icons/md";
// import { MdOutlineElectricBolt } from "react-icons/md";
// import ElectricityDetails from "./ElectricityDetails";
// import AdvanceRent from "./AdvanceRent";
// import Security from "./Security";
// import Maintenance from "./Maintenance";
// import Food from "./Food";
// import Fine from "./Fine";
// import RegistrationCharges from "./RegistrationCharges";
// import WifiCharges from "./WifiCharges";
// import GasCharges from "./GasCharges";
// import MaidCharges from "./MaidCharges";
// import DamageCharges from "./DamageCharges";
// import KeyLossCharges from "./KeyLossCharges";
// import LaundryBill from "./LaundryBill";
// import OthersModal from "./OthersModal";
// import { CiCalendarDate } from "react-icons/ci";
// import { MdFoodBank} from "react-icons/md";
// import { GiAutoRepair } from "react-icons/gi";
// import { MdShield } from "react-icons/md";
// import { GiNotebook } from "react-icons/gi";
// import { FaWifi } from "react-icons/fa";
// import { MdGasMeter } from "react-icons/md";
// import { FaBroom } from "react-icons/fa";
// import { FaKey } from "react-icons/fa";
// import { GiWashingMachine } from "react-icons/gi";
// import { FaHouseDamage } from "react-icons/fa";
// import { FaWallet } from "react-icons/fa";

// const AddDuesModal = ({ setIsAddDuesModal }) => {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const selectOptions = [
//         { value: "1", label: "Advance Rent" },
//         { value: "2", label: "Security" },
//         { value: "3", label: "Maintenance" },
//         { value: "4", label: "Electricity" },
//         { value: "5", label: "Registration Charges" },
//         { value: "6", label: "Food" },
//         { value: "7", label: "Fine" },
//         { value: "8", label: "Wifi Charges" },
//         { value: "9", label: "Gas Charges" },
//         { value: "10", label: "Maid Charges" },
//         { value: "11", label: "Damage Charges" },
//         { value: "12", label: "Key Loss Charges" },
//         { value: "13", label: "Laundry Bill" },
//         { value: "14", label: "Others" },
//     ];

//     const renderContent = () => {
//         switch (selectedOption) {
//             case "1":
//                 return <AdvanceRent setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//              case "2":
//                 return <Security setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "3":
//                 return <Maintenance setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "4":
//                 return <ElectricityDetails setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "5":
//                 return <RegistrationCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "6":
//                 return <Food setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "7":
//                 return <Fine setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "8":
//                 return <WifiCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "9":
//                 return <GasCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "10":
//                 return <MaidCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "11":
//                 return <DamageCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "12":
//                 return <KeyLossCharges setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "13":
//                 return <LaundryBill setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             case "14":
//                 return <OthersModal setIsAddDuesModal={setIsAddDuesModal} setSelectedOption={setSelectedOption} />;
//             default:
//                 return (
//                     <Form>
//                         <Wrapper>
//                             <DuesGroup>
//                                 {selectOptions.map((option) => (
//                                     <DuesOption
//                                         key={option.value}
//                                         onClick={() => {
//                                             setSelectedOption(option.value);
//                                         }}
//                                     >
//                                         <RadioContainer>
//                                             <RadioCircle isSelected={selectedOption === option.value} />
//                                             <span className="text-sm">{option.label}</span>
//                                         </RadioContainer>
//                                     </DuesOption>
//                                 ))}
//                             </DuesGroup>
//                         </Wrapper>
//                     </Form>
//                 );
//         }
//     };
//     const renderHeader = () => {
//         switch (selectedOption) {
//             case "1":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <CiCalendarDate size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Advance Rent</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "2":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <MdShield size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Security</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "3":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <GiAutoRepair size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Maintenance</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "4":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <MdOutlineElectricBolt size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Electricity</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "5":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <GiNotebook size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Registration Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "6":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <MdFoodBank size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Food</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "7":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <GiAutoRepair size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Fine</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "8":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <FaWifi size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Wifi Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "9":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <MdGasMeter size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Gas Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "10":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <FaBroom  size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Maid Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "11":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <FaHouseDamage size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Damage Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "12":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <FaKey size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Key Loss Charges</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "13":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <GiWashingMachine size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Laundry Bill</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );
//             case "14":
//                 return (
//                     <ProfileSection>
//                         <UserImage>
//                             <FaWallet  size={18} color="#0078BD" />
//                         </UserImage>
//                         <UserInfo>
//                             <span className="font-medium">Others</span>
//                         </UserInfo>
//                     </ProfileSection>
//                 );  
//             default:
//         }
//     };
//     return (
//         <Container>
//             <Header>
//                 <Title>{selectedOption ? "Add Dues" : "Select Dues Type"}</Title>
//                 <CloseButton onClick={() => setIsAddDuesModal(false)}>
//                     <MdClose size={24} />
//                 </CloseButton>
//             </Header>
//             {renderHeader()}
//             <Content>
//                 {renderContent()}
//             </Content>
//         </Container>
//     );
// };

// const Container = tw.div`bg-white w-full h-full flex flex-col`;
// const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
// const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
// const CloseButton = tw.button`text-white`;
// const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
// const Form = tw.form`flex flex-col h-full justify-between`;
// const Wrapper = tw.div`grid gap-6 my-6`;
// const DuesGroup = tw.div`flex flex-col gap-3 `;
// const DuesOption = tw.div`
//     flex flex-col gap-2 p-4 border rounded-lg cursor-pointer
//     transition-all duration-200 hover:bg-gray-100
// `;
// const RadioContainer = tw.div`flex items-center gap-3 `;
// const RadioCircle = ({ isSelected }) => (
//     <div
//         className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${isSelected ? "border-blue-500" : "border-gray-500"
//             }`}
//     >
//         {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
//     </div>
// );
// const UserImage = tw.div`flex w-8 h-8 rounded-full  bg-blue-200 justify-center items-center `;
// const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 py-5`;
// const UserInfo = tw.div`flex flex-col`;

// export default AddDuesModal;
